/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ListIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 34 29"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-39.000000, -428.000000)">
        <g transform="translate(40.000000, 426.000000)">
          <g
            transform="translate(0.000000, 2.666667)"
            stroke="#36A496"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          >
            <g>
              <path d="M8.66666667,3.33333333 L31.3333333,3.33333333" />
              <path d="M8.66666667,14 L31.3333333,14" />
              <path d="M8.66666667,24.6666667 L31.3333333,24.6666667" />
              <polyline points="2.66666667 6 2.66666667 0.764 0.666666667 2.716" />
              <path d="M3.42533333,16.6666667 L0.666666667,16.6666667 C2.64,14 3.33333333,14.2186667 3.33333333,12.716 C3.33333333,11.98 2.73466667,11.4066667 2,11.4066667 C1.26266667,11.4066667 0.713333333,11.9693333 0.713333333,12.7053333" />
              <path d="M0.666666667,22 L3.24133333,22 L1.908,24.0493333 C3.00933333,24.0493333 3.24133333,24.6906667 3.24133333,25.3573333 C3.24133333,26.024 3.00933333,26.6666667 1.908,26.6666667 L0.666666667,26.6666667" />
            </g>
          </g>
          <g>
            <rect x="0" y="0" width="32" height="32" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ListIcon;
